import { render, staticRenderFns } from "./OpenApp.vue?vue&type=template&id=283644dc&scoped=true&"
import script from "./OpenApp.vue?vue&type=script&lang=js&"
export * from "./OpenApp.vue?vue&type=script&lang=js&"
import style0 from "./OpenApp.vue?vue&type=style&index=0&id=283644dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283644dc",
  null
  
)

export default component.exports